<template>
  <button
    v-if="hasText"
    @click.stop="handleCopy"
    class="copy-btn relative inline-flex flex-shrink-0 p-0.5 rounded hover:bg-gray-200 align-middle"
    :title="title"
  >
    <transition name="copy-icon" mode="out-in">
      <svg
        v-if="!copied"
        key="copy"
        xmlns="http://www.w3.org/2000/svg"
        class="h-3.5 w-3.5 text-gray-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
        />
      </svg>
      <svg
        v-else
        key="check"
        xmlns="http://www.w3.org/2000/svg"
        class="h-3.5 w-3.5 text-green-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </transition>
    <transition name="copy-tip">
      <span
        v-if="copied"
        class="copy-tip absolute left-full ml-1 top-1/2 px-1.5 py-0.5 rounded bg-green-600 text-white text-[10px] font-semibold uppercase pointer-events-none whitespace-nowrap shadow"
      >
        Copied!
      </span>
    </transition>
  </button>
</template>

<script>
export default {
  name: "base-copy-button",
  props: {
    text: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: "Copy"
    }
  },
  data() {
    return {
      copied: false,
      copyTimer: null
    };
  },
  computed: {
    hasText() {
      return this.text !== null && this.text !== undefined && String(this.text).length > 0;
    }
  },
  beforeUnmount() {
    if (this.copyTimer) clearTimeout(this.copyTimer);
  },
  methods: {
    async handleCopy() {
      const value = String(this.text == null ? "" : this.text);
      if (!value) return;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(value);
        } else {
          // Fallback for non-secure contexts / older browsers
          const ta = document.createElement("textarea");
          ta.value = value;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        this.copied = true;
        if (this.copyTimer) clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          this.copied = false;
        }, 1200);
      } catch (e) {
        // Silently swallow — copy failures shouldn't disrupt the UI.
      }
    }
  }
};
</script>

<style scoped>
.copy-btn {
  line-height: 0;
}

.copy-icon-enter-active,
.copy-icon-leave-active {
  transition: transform 0.18s ease, opacity 0.18s ease;
}
.copy-icon-enter-from {
  transform: scale(0.4) rotate(-12deg);
  opacity: 0;
}
.copy-icon-leave-to {
  transform: scale(0.4) rotate(12deg);
  opacity: 0;
}

.copy-tip {
  transform: translateY(-50%);
}
.copy-tip-enter-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.copy-tip-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.copy-tip-enter-from {
  opacity: 0;
  transform: translate(-6px, -50%);
}
.copy-tip-leave-to {
  opacity: 0;
  transform: translate(6px, -50%);
}
</style>
